<template>
  <div>
     <table>
            <tr>
              <th>{{$t('lang.particulars.YTCommunityTag')}}</th>
              <td v-if="list.n2nInfoAndN2n">{{list.n2nInfoAndN2n.n2nInfoGname}}</td>
              <td v-else>N/A</td>
              <th>{{$t('lang.particulars.password')}}</th>
              <td v-if="list.n2nInfoAndN2n">{{list.n2nInfoAndN2n.n2nInfoGpassword}}</td>
              <td v-else>N/A</td>
            </tr>
            <tr>
              <th>{{$t('lang.particulars.YTCommuniIP')}}</th>
              <td v-if="list.n2nInfoAndN2n">{{list.n2nInfoAndN2n.n2nIp}}</td>
              <td v-else>N/A</td>
              <th>{{$t('lang.particulars.Operation')}}</th>
              <td v-if="Permission.indexOf(152)!=-1">
                <el-button
                  type="danger"
                  @click="remn2n"
                  size="mini"
                >{{$t('lang.particulars.AtomServiceDualParser')}}</el-button>
              </td>
            </tr>
          </table>
  </div>
</template>
<script>
export default {
  props: ['list', 'Permission'],
  data() {
    return {

    }
  },
  methods: {
    remn2n() {
      this.$emit('remn2n')
    }
  }
}
</script>
<style scoped src='./particulars.css'></style>